/* DEPIX — Edge : theme runtime */
(function () {
  'use strict';

  var T = window.Theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------
     money
  --------------------------------------------------------------- */
  function formatMoney(cents, format) {
    var fmt = format || T.moneyFormat || '${{amount}}';
    function pad(n, l) { n = String(n); while (n.length < l) n = '0' + n; return n; }
    function thousands(num, sep) {
      var parts = num.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
      return parts.join('.');
    }
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    var name = match ? match[1] : 'amount';
    var amount = Number(cents) / 100;

    switch (name) {
      case 'amount_no_decimals':
        value = thousands(String(Math.round(amount)), ',');
        break;
      case 'amount_with_comma_separator':
        value = thousands(amount.toFixed(2), '.').replace(/\.(\d\d)$/, ',$1');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = thousands(String(Math.round(amount)), '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = thousands(String(Math.round(amount)), ' ');
        break;
      case 'amount_with_space_separator':
        value = thousands(amount.toFixed(2), ' ').replace(/\.(\d\d)$/, ',$1');
        break;
      case 'amount_with_period_and_space_separator':
        value = thousands(amount.toFixed(2), ' ');
        break;
      default:
        value = thousands(amount.toFixed(2), ',');
    }
    return fmt.replace(placeholder, value);
  }
  window.formatMoney = formatMoney;

  /* ---------------------------------------------------------------
     toast
  --------------------------------------------------------------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 2600);
  }

  /* ---------------------------------------------------------------
     overlay + panels
  --------------------------------------------------------------- */
  var overlay = null;
  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'overlay';
      overlay.addEventListener('click', closeAll);
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  var openPanels = [];

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    getOverlay().classList.add('is-open');
    document.body.classList.add('is-locked');
    if (openPanels.indexOf(el) === -1) openPanels.push(el);
    var focusable = el.querySelector('input:not([type=hidden]), button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 260);
  }

  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openPanels = openPanels.filter(function (p) { return p !== el; });
    if (!openPanels.length) {
      getOverlay().classList.remove('is-open');
      document.body.classList.remove('is-locked');
    }
  }

  function closeAll() {
    openPanels.slice().forEach(closePanel);
  }

  // a section swap can replace an open panel's node; drop the orphans so the
  // overlay and the scroll lock do not outlive it
  function syncPanels() {
    openPanels = openPanels.filter(function (p) { return document.body.contains(p); });
    if (!openPanels.length) {
      getOverlay().classList.remove('is-open');
      document.body.classList.remove('is-locked');
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var sel = opener.getAttribute('data-open');
      var panel = $(sel);
      if (panel) {
        e.preventDefault();
        openPanel(panel);
        return;
      }
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      var target = closer.getAttribute('data-close');
      closePanel(target ? $(target) : closer.closest('.drawer, .fdrawer, .modal, .search-drawer, .mobile-menu'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ---------------------------------------------------------------
     the mobile menu ships inside the header section, but that section is
     position:sticky with a z-index, so it owns a stacking context the menu
     can never escape — it would render under the dim overlay. Move it to
     <body> so its own z-index counts.
  --------------------------------------------------------------- */
  function portalMobileMenu() {
    $$('.shopify-section .mobile-menu').forEach(function (menu) {
      var stale = $('body > .mobile-menu');
      if (stale) stale.remove();
      document.body.appendChild(menu);
    });
  }
  portalMobileMenu();
  document.addEventListener('shopify:section:load', portalMobileMenu);

  /* ---------------------------------------------------------------
     sticky / overlay header
  --------------------------------------------------------------- */
  (function header() {
    var group = $('.header-group');
    if (!group) return;

    var header = group.querySelector('.header');
    var ann = $('.announcement-section');
    var root = document.documentElement;

    // --header-h feeds sticky offsets only; nothing it sets may change the
    // header's own height or the observer would chase itself
    function set(name, px) {
      var next = px + 'px';
      if (root.style.getPropertyValue(name) !== next) root.style.setProperty(name, next);
    }

    function measure() {
      if (header) set('--header-h', Math.round(header.getBoundingClientRect().height));
      set('--ann-h', ann ? Math.round(ann.getBoundingClientRect().height) : 0);
    }
    measure();

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      if (header) ro.observe(header);
      if (ann) ro.observe(ann);
    }
    window.addEventListener('resize', measure);

    if (!group.classList.contains('is-overlay')) return;

    document.body.classList.add('has-overlay-header');

    var onScroll = function () {
      var threshold = (ann ? ann.offsetHeight : 0) + 10;
      var scrolled = window.scrollY > threshold;
      group.classList.toggle('is-stuck', scrolled);
      document.body.classList.toggle('is-scrolled', scrolled);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------------------------------------------------------------
     cart
  --------------------------------------------------------------- */
  var Cart = {
    state: null,

    init: function () {
      var node = $('#ThemeCartState');
      if (node) { try { Cart.state = JSON.parse(node.textContent); } catch (e) {} }
    },

    async add(items, opts) {
      opts = opts || {};
      var res = await fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      var data = await res.json();
      if (!res.ok) {
        toast(data.description || data.message || 'Could not add to cart');
        throw new Error(data.description || 'add failed');
      }
      await Cart.refresh();
      if (T.cartDrawer && !opts.silent) {
        openPanel($('#CartDrawer'));
      } else {
        toast(T.strings.added);
      }
      return data;
    },

    async change(line, quantity) {
      var res = await fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      var data = await res.json();
      Cart.state = data;
      await Cart.refresh();
      return data;
    },

    async refresh() {
      var res = await fetch(T.routes.root + '?sections=cart-drawer');
      var data = await res.json();
      var html = data['cart-drawer'];
      if (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        var current = $('#CartDrawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
      }
      var cRes = await fetch(T.routes.root + 'cart.js');
      var cart = await cRes.json();
      Cart.state = cart;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      // refresh the cart page if we are on it
      if (document.body.classList.contains('template-cart')) {
        var pRes = await fetch(window.location.pathname + '?sections=main-cart');
        var pData = await pRes.json();
        var holder = $('#MainCart');
        if (holder && pData['main-cart']) {
          var t2 = document.createElement('div');
          t2.innerHTML = pData['main-cart'];
          var f2 = t2.querySelector('#MainCart');
          if (f2) holder.innerHTML = f2.innerHTML;
        }
      }
    }
  };
  Cart.init();
  window.ThemeCart = Cart;

  // qty + remove inside cart surfaces
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.qty');
      var input = wrap.querySelector('input');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      Cart.change(parseInt(rm.getAttribute('data-cart-remove'), 10), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-cart-qty'), 10);
    Cart.change(line, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------------------------------------------------------------
     product form (PDP + quick add)
  --------------------------------------------------------------- */
  function bindProductForm(root) {
    var form = root.querySelector('[data-product-form]');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';

    var variantsNode = root.querySelector('[data-variants]');
    var variants = [];
    if (variantsNode) { try { variants = JSON.parse(variantsNode.textContent); } catch (e) {} }

    var idInput = form.querySelector('[name="id"]');
    var submit = form.querySelector('[type="submit"]');
    var priceEl = root.querySelector('[data-price]');
    var statusEl = root.querySelector('[data-stock-status]');
    var groups = $$('[data-option-group]', root);
    var isPdp = !!root.closest('.pdp');
    var selected = null;

    // current selection, indexed by option position - 1
    var chosen = groups.map(function (g) {
      var on = g.querySelector('[data-opt][aria-checked="true"]');
      return on ? on.getAttribute('data-value') : null;
    });

    function matchVariant(values) {
      return variants.filter(function (v) {
        return values.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function renderPrice(v) {
      if (!priceEl) return;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceEl.innerHTML =
          '<s class="price--was">' + formatMoney(v.compare_at_price) + '</s>' +
          '<span class="price--sale">' + formatMoney(v.price) + '</span>';
      } else {
        priceEl.innerHTML = formatMoney(v.price);
      }
    }

    function renderStatus(available) {
      if (!statusEl) return;
      var dot = statusEl.querySelector('.dot');
      var label = statusEl.querySelector('span:last-child');
      if (dot) dot.classList.toggle('dot--out', !available);
      if (label) label.textContent = available ? (statusEl.getAttribute('data-in-label') || 'Buy now') : T.strings.soldOut;
    }

    // grey out values that cannot be reached with the rest of the selection
    function refreshAvailability() {
      groups.forEach(function (group, gi) {
        $$('[data-opt]', group).forEach(function (btn) {
          var probe = chosen.slice();
          probe[gi] = btn.getAttribute('data-value');
          // only constrain by earlier groups so later ones stay explorable
          for (var i = gi + 1; i < probe.length; i++) probe[i] = null;
          var reachable = matchVariant(probe).some(function (v) { return v.available; });
          btn.classList.toggle('is-soldout', !reachable);
        });
      });
    }

    function resolve() {
      var complete = chosen.every(function (v) { return v !== null; });
      groups.forEach(function (group, gi) {
        var out = group.querySelector('[data-option-selected]');
        if (out) out.textContent = chosen[gi] || '';
      });
      refreshAvailability();

      if (!complete) {
        selected = null;
        if (submit) { submit.disabled = true; submit.textContent = T.strings.selectSize; }
        return;
      }
      var v = matchVariant(chosen)[0];
      selected = v || null;
      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = T.strings.unavailable; }
        renderStatus(false);
        return;
      }
      idInput.value = v.id;
      renderPrice(v);
      renderStatus(v.available);
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      }
      if (isPdp) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    groups.forEach(function (group, gi) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-opt]');
        if (!btn || btn.classList.contains('is-soldout')) return;
        $$('[data-opt]', group).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        chosen[gi] = btn.getAttribute('data-value');
        resolve();
      });
    });

    if (groups.length === 0) {
      selected = variants[0] || null;
    } else {
      // a single-variant product arrives preselected; otherwise force a choice
      if (variants.length === 1) {
        groups.forEach(function (group, gi) {
          var btn = group.querySelector('[data-opt]');
          if (btn) { btn.setAttribute('aria-checked', 'true'); chosen[gi] = btn.getAttribute('data-value'); }
        });
      } else {
        chosen = chosen.map(function () { return null; });
        $$('[data-opt]', root).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      }
      resolve();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!selected || !selected.available) return;
      var original = submit.textContent;
      submit.disabled = true;
      submit.innerHTML = '<span class="spinner"></span>';
      Cart.add([{ id: selected.id, quantity: 1 }])
        .then(function () {
          closePanel($('#QuickAdd'));
          submit.textContent = original;
          submit.disabled = false;
        })
        .catch(function () {
          submit.textContent = original;
          submit.disabled = false;
        });
    });
  }

  $$('[data-product-root]').forEach(bindProductForm);

  /* ---------------------------------------------------------------
     quick add
  --------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add]');
    if (!trigger) return;
    e.preventDefault();
    var handle = trigger.getAttribute('data-quick-add');
    var modal = $('#QuickAdd');
    var body = $('[data-quick-add-body]', modal);
    body.innerHTML = '<div style="display:grid;place-items:center;padding:40px"><span class="spinner"></span></div>';
    openPanel(modal);
    fetch(T.routes.root + 'products/' + handle + '?section_id=quick-add')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var content = tmp.querySelector('[data-quick-add-content]');
        body.innerHTML = content ? content.innerHTML : '';
        bindProductForm(body);
      })
      .catch(function () {
        body.innerHTML = '<p class="t-muted">Unable to load.</p>';
      });
  });

  /* ---------------------------------------------------------------
     colourway siblings — colour is a separate product, so strip the colour
     word out of the title and group the products that share the remainder
  --------------------------------------------------------------- */
  (function colorways() {
    var holder = $('[data-colorways]');
    if (!holder) return;

    var title = holder.getAttribute('data-title') || '';
    var current = holder.getAttribute('data-handle');
    var colors = (holder.getAttribute('data-colors') || '')
      .split(',')
      .map(function (c) { return c.replace(/[^a-z0-9]+/gi, ' ').trim().toLowerCase(); })
      .filter(Boolean)
      .sort(function (a, b) { return b.length - a.length; }); // "dark blue" before "blue"

    function stem(value) {
      var t = ' ' + value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
      colors.forEach(function (c) { t = t.split(' ' + c + ' ').join(' '); });
      return t.replace(/\s+/g, ' ').trim();
    }

    var base = stem(title);
    if (!base || base.split(' ').length < 2) return; // too generic to group on

    fetch(T.routes.searchSuggest + '?q=' + encodeURIComponent(base) +
          '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (((data.resources || {}).results || {}).products) || [];
        var matches = products.filter(function (p) { return stem(p.title) === base; });
        if (matches.length < 2) return;

        var html = matches.map(function (p) {
          var isCurrent = p.handle === current;
          var img = (p.featured_image && p.featured_image.url) || p.image;
          var safe = p.title.replace(/"/g, '');
          return '<a class="colorway" href="' + p.url + '" aria-current="' + (isCurrent ? 'true' : 'false') +
            '" title="' + safe + '">' +
            (img ? '<img src="' + img + '" alt="' + safe + '" loading="eager" width="72" height="72">' : '') +
            '</a>';
        }).join('');

        holder.innerHTML =
          '<div class="opt-group__label">' +
            '<span>' + holder.getAttribute('data-label') + '<sup>' + matches.length + '</sup></span>' +
          '</div>' +
          '<div class="colorways">' + html + '</div>';
        holder.hidden = false;
      })
      .catch(function () {});
  })();

  /* ---------------------------------------------------------------
     colour dots on a card: swap the card in place instead of opening the
     other colour's product page. The dot keeps its href, so without JS — and
     for crawlers — it still behaves as a plain link.
  --------------------------------------------------------------- */
  (function swatchSwap() {
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-swatch]');
      if (!dot) return;
      var card = dot.closest('.card');
      if (!card) return;
      e.preventDefault();
      if (dot.classList.contains('is-active')) return;

      var d = dot.dataset;
      var media = card.querySelector('[data-card-media]');
      var main = card.querySelector('.card__img--main');
      var hover = card.querySelector('.card__img--alt');
      var title = card.querySelector('[data-card-title]');
      var price = card.querySelector('[data-card-price]');
      var badges = card.querySelector('[data-card-badges]');
      var add = card.querySelector('.card__add');

      if (media && d.url) {
        media.setAttribute('href', d.url);
        if (d.title) media.setAttribute('aria-label', d.title);
      }

      if (main && d.img) {
        main.setAttribute('src', d.img);
        if (d.srcset) main.setAttribute('srcset', d.srcset);
        else main.removeAttribute('srcset');
        main.setAttribute('alt', d.alt || d.title || '');
      }

      if (hover) {
        if (d.hover) {
          hover.setAttribute('src', d.hover);
          if (d.hoverSrcset) hover.setAttribute('srcset', d.hoverSrcset);
          else hover.removeAttribute('srcset');
          hover.hidden = false;
        } else {
          hover.hidden = true;
        }
      }

      if (title) {
        if (d.title) {
          title.textContent = d.title;
          title.setAttribute('title', d.title);
        }
        if (d.url) title.setAttribute('href', d.url);
      }
      if (price && d.price != null) price.innerHTML = d.price;
      if (badges && d.badges != null) badges.innerHTML = d.badges;

      if (add && d.handle) {
        add.setAttribute('data-quick-add', d.handle);
        add.classList.toggle('is-hidden', d.available === 'false');
      }

      $$('[data-swatch]', card).forEach(function (s) {
        s.classList.toggle('is-active', s === dot);
      });
    });
  })();

  /* ---------------------------------------------------------------
     predictive search
  --------------------------------------------------------------- */
  (function search() {
    var drawer = $('#SearchDrawer');
    if (!drawer) return;
    var input = $('[data-search-input]', drawer);
    var results = $('[data-search-results]', drawer);
    var timer;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var c = tmp.querySelector('[data-predictive]');
            results.innerHTML = c ? c.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  })();

  /* ---------------------------------------------------------------
     audience toggle — swaps every card and gallery to the other model's
     shots. Pure class flip on <html>, so nothing reloads.
  --------------------------------------------------------------- */
  (function audience() {
    var KEY = 'depix:aud';

    function side() {
      return document.documentElement.classList.contains('aud-b') ? 'b' : 'a';
    }

    function paint() {
      var isB = side() === 'b';
      $$('[data-audience]').forEach(function (group) {
        $$('[data-aud]', group).forEach(function (label) {
          label.classList.toggle('is-on', label.getAttribute('data-aud') === (isB ? 'b' : 'a'));
        });
        var sw = group.querySelector('[data-aud-switch]');
        if (sw) {
          sw.classList.toggle('is-b', isB);
          sw.setAttribute('aria-checked', String(isB));
        }
      });
    }

    function set(to) {
      document.documentElement.classList.toggle('aud-b', to === 'b');
      try { localStorage.setItem(KEY, to); } catch (e) {}
      paint();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-aud-switch]')) {
        e.preventDefault();
        set(side() === 'b' ? 'a' : 'b');
        return;
      }
      var label = e.target.closest('[data-aud]');
      if (label && label.closest('[data-audience]')) {
        e.preventDefault();
        set(label.getAttribute('data-aud'));
      }
    });

    paint();
    document.addEventListener('shopify:section:load', paint);
  })();

  /* ---------------------------------------------------------------
     filter drawer: sort pills + dual-handle price range
  --------------------------------------------------------------- */
  function bindFilters(root) {
    var scope = root || document;

    $$('[data-sort-pill]', scope).forEach(function (pill) {
      if (pill.dataset.bound) return;
      pill.dataset.bound = '1';
      pill.addEventListener('click', function () {
        var form = pill.closest('[data-filter-form]');
        var input = form && form.querySelector('[data-sort-input]');
        if (!input) return;
        $$('[data-sort-pill]', form).forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        pill.setAttribute('aria-pressed', 'true');
        input.value = pill.getAttribute('data-sort-pill');
        form.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    $$('[data-frange]', scope).forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';

      var max = parseInt(wrap.getAttribute('data-max'), 10) || 0;
      var lo = wrap.querySelector('[data-frange-min]');
      var hi = wrap.querySelector('[data-frange-max]');
      var fill = wrap.querySelector('[data-frange-fill]');
      var loField = wrap.querySelector('[data-frange-min-field]');
      var hiField = wrap.querySelector('[data-frange-max-field]');
      var loLabel = wrap.querySelector('[data-frange-min-label]');
      var hiLabel = wrap.querySelector('[data-frange-max-label]');
      if (!lo || !hi || !max) return;

      function paint() {
        var a = Math.min(+lo.value, +hi.value);
        var b = Math.max(+lo.value, +hi.value);
        fill.style.left = (a / max * 100) + '%';
        fill.style.right = (100 - b / max * 100) + '%';
        if (loLabel) loLabel.textContent = a;
        if (hiLabel) hiLabel.textContent = b;
        // leave the param out entirely when the handle sits on its bound
        if (loField) loField.value = a > 0 ? a : '';
        if (hiField) hiField.value = b < max ? b : '';
      }

      function clamp(moved) {
        if (+lo.value > +hi.value) {
          if (moved === lo) lo.value = hi.value;
          else hi.value = lo.value;
        }
      }

      [lo, hi].forEach(function (input) {
        input.addEventListener('input', function () { clamp(input); paint(); });
      });

      paint();
    });
  }
  bindFilters();

  /* ---------------------------------------------------------------
     collection: sort, filters, load more
  --------------------------------------------------------------- */
  (function collection() {
    var root = $('[data-collection-root]');
    if (!root) return;

    function swap(url, push) {
      var sectionId = root.getAttribute('data-section-id');
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      var drawer = $('#FilterDrawer');
      var keepFiltersOpen = !!drawer && drawer.classList.contains('is-open');

      root.classList.add('is-loading');
      return fetch(url + sep + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-collection-root]');
          if (fresh) root.innerHTML = fresh.innerHTML;
          if (push !== false) window.history.pushState({}, '', url);
          root.classList.remove('is-loading');

          bindFilters(root);
          syncPanels();
          if (keepFiltersOpen) {
            openPanel($('#FilterDrawer'));
          } else {
            window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' });
          }
        })
        .catch(function () {
          root.classList.remove('is-loading');
          window.location.href = url;
        });
    }

    root.addEventListener('click', function (e) {
      var sort = e.target.closest('[data-sort]');
      if (sort) {
        e.preventDefault();
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.getAttribute('data-sort'));
        u.searchParams.delete('page');
        swap(u.toString());
        return;
      }

      var more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        var next = more.getAttribute('href');
        more.innerHTML = '<span class="spinner"></span>';
        var sid = root.getAttribute('data-section-id');
        fetch(next + (next.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sid)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var newGrid = tmp.querySelector('.pgrid');
            var grid = root.querySelector('.pgrid');
            if (newGrid && grid) {
              Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
            }
            var newMore = tmp.querySelector('[data-load-more]');
            var wrap = more.parentElement;
            if (newMore) { wrap.innerHTML = newMore.outerHTML; }
            else { wrap.remove(); }
            window.history.replaceState({}, '', next);
          });
        return;
      }

      var clearChip = e.target.closest('[data-filter-remove]');
      if (clearChip) {
        e.preventDefault();
        swap(clearChip.getAttribute('href'));
      }
    });

    // filter form (live)
    document.addEventListener('change', function (e) {
      var form = e.target.closest('[data-filter-form]');
      if (!form) return;
      var params = new URLSearchParams(new FormData(form));
      // strip empties
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      swap(window.location.pathname + '?' + clean.toString());
    });

    window.addEventListener('popstate', function () {
      swap(window.location.href, false);
    });
  })();

  /* ---------------------------------------------------------------
     related products (Shopify recommendations)
  --------------------------------------------------------------- */
  (function related() {
    var holder = $('[data-related]');
    if (!holder) return;
    fetch(holder.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-related]');
        if (fresh) holder.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  })();

  /* ---------------------------------------------------------------
     sticky add-to-cart on mobile PDP
  --------------------------------------------------------------- */
  (function stickyAtc() {
    var bar = $('.sticky-atc');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor) return;

    var ticking = false;

    function update() {
      ticking = false;
      // show it only once the real buy block has scrolled out of reach
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 60);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-add]')) {
        e.preventDefault();
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  })();

  /* ---------------------------------------------------------------
     arrivals tabs
  --------------------------------------------------------------- */
  function bindArrivals(root) {
    $$('[data-arrivals]', root || document).forEach(function (section) {
      if (section.dataset.bound) return;
      section.dataset.bound = '1';

      var tabs = $$('[data-tab]', section);
      var panels = $$('[data-panel]', section);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
        });
      });
    });
  }
  bindArrivals();

  /* ---------------------------------------------------------------
     fullscreen collection nav — mark the slide under the viewport
  --------------------------------------------------------------- */
  function bindFsnav(root) {
    $$('[data-fsnav]', root || document).forEach(function (section) {
      if (section.dataset.bound) return;
      section.dataset.bound = '1';

      var items = $$('[data-fsnav-item]', section);
      var slides = $$('[data-fsnav-slide]', section);
      if (!items.length || !slides.length) return;

      var ticking = false;

      function update() {
        ticking = false;
        var mid = window.innerHeight / 2;
        var active = 0;
        slides.forEach(function (slide, i) {
          var r = slide.getBoundingClientRect();
          if (r.top <= mid && r.bottom >= mid) active = i;
        });
        items.forEach(function (item, i) {
          item.setAttribute('aria-current', String(i === active));
        });
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      // clicking a label jumps to its slide rather than leaving straight away
      items.forEach(function (item, i) {
        item.addEventListener('click', function (e) {
          var r = slides[i].getBoundingClientRect();
          var onScreen = r.top <= window.innerHeight / 2 && r.bottom >= window.innerHeight / 2;
          if (onScreen) return; // already looking at it — follow the link
          e.preventDefault();
          window.scrollTo({ top: window.scrollY + r.top, behavior: 'smooth' });
        });
      });
    });
  }
  bindFsnav();

  document.addEventListener('shopify:section:load', function (e) {
    bindArrivals(e.target);
    bindFsnav(e.target);
  });

  /* ---------------------------------------------------------------
     sliders (dots)
  --------------------------------------------------------------- */
  $$('[data-slider]').forEach(function (slider) {
    var dotsWrap = slider.parentElement.querySelector('[data-slider-dots]');
    if (!dotsWrap) return;
    var slides = Array.prototype.slice.call(slider.children);
    dotsWrap.innerHTML = slides.map(function (_, i) {
      return '<button type="button" aria-label="Slide ' + (i + 1) + '" aria-current="' + (i === 0) + '"></button>';
    }).join('');
    var dots = Array.prototype.slice.call(dotsWrap.children);
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        slider.scrollTo({ left: slides[i].offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      });
    });
    slider.addEventListener('scroll', function () {
      var idx = Math.round(slider.scrollLeft / slider.clientWidth);
      dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === idx)); });
    }, { passive: true });
  });

  /* ---------------------------------------------------------------
     share
  --------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-share') || window.location.href;
    if (navigator.share) { navigator.share({ url: url }).catch(function () {}); }
    else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast(T.strings.copied); });
    }
  });

  /* ---------------------------------------------------------------
     theme editor hooks
  --------------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-root]', e.target).forEach(bindProductForm);
  });
})();
